export enum SerialDecoders {
  PromagPCR300,
  AdmittoA1200,
  // just a dummy decode to signal that the decoding is done by the Photino app
  Photino
}
